import { notifError } from "actions/FlashMessageActions";
import { removeUserData, removeUserSession } from "actions/LoginActions";
import auth from "utils/Auth";
import i18n from "../i18n";

/**
 * Based on the lib we use to communicate with the API, we retrive the data
 * differently.
 */
const getData = (response) => {
  if (response.config && response.config.method === "get") return response.data;

  return response.json();
};

const getError = (error, response) =>
  response.json().then((json) => ({
    errorType: error,
    errorDetails: json,
  }));

export const triggerError = (dispatch, e, cbError) => {
  // If the backend reply 'unauthorized' we clean up the session data
  if (e.message === "unauth" || e.message.match(/.*301.*/)) {
    dispatch(removeUserSession());
    dispatch(removeUserData());
    auth.setSession("false", "", "");
  }

  // If the error was because of the network, backend errors or programming errors
  // we display a generic error message.
  if (e.message === "systemFailure") {
    console.error(i18n.t("error:genericError"));
  } else if (cbError) {
    // If it wasn't a generic error and the component defined an error message (or a localized error key)
    // we display it, otherwise we ignore the error.
    if (e.details?.error) {
      const { error } = e.details;
      // Error can be a simple string or an array of object:
      // ({reason:'translation', message:'duplicate_slug'}, reason can be null)
      if (Array.isArray(error)) {
        error.forEach(({ reason, message }) => {
          const msg = reason
            ? `error:${reason}:${message}`
            : `error:${message}`;
          dispatch(notifError(i18n.t(msg)));
        });
      } else {
        dispatch(notifError(i18n.t(`error:${error}`)));
      }
    } else {
      dispatch(notifError(i18n.t(`error:${cbError}`)));
    }
  }
};

/**
 * Handles http return codes from the API
 */
export const handleErrors = (response) => {
  switch (response.status) {
    case 200:
    case 201:
    case 203:
    case 205:
    case 206:
      return getData(response);
    case 202:
    case 204:
    case 302:
    case 304:
    case 307:
      return true;
    case 400:
      return getError("badRequest", response);
    case 402:
    case 403:
      throw new Error("customError");
    case 401:
      throw new Error("unauthorized");
    case 409:
      return getError("conflictError", response);
    default:
      // Whatever was the error we won't display it to the user
      throw new Error("systemFailure");
  }
};

/**
 * Creates the http headers object based on the token value
 */
export const formatHeaders = (token, customHeader) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (token && token.length > 0) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (customHeader && customHeader.length > 0) {
    customHeader.map((header) => (headers[header.key] = header.value));
  }

  return headers;
};

window.formatHeaders = formatHeaders;
